import BusinessTripDialog from './BusinessTripDialog';

export default BusinessTripDialog;
